import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import TableChartIcon from '@material-ui/icons/TableChart';
import React from 'react';
import { Box } from '../UI';

export default function FloatingMenu({ isOpen, setOpen }) {
	const classes = useStyles(isOpen);
	return (
		<div className={classes.menu}>
			<nav>
				<Box display="flex" flexDirection="row" justifyContent="center">
					<Tooltip title="Upload" aria-label="upload">
						<IconButton className={classes.icon} aria-label="menu">
							<CloudUploadIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Research" aria-label="research">
						<IconButton className={classes.icon} aria-label="menu">
							<FindInPageIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Finance" aria-label="finance">
						<IconButton className={classes.icon} aria-label="menu">
							<MonetizationOnIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Modelling" aria-label="modelling">
						<IconButton className={classes.icon} aria-label="menu">
							<TableChartIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Valuations" aria-label="valuations">
						<IconButton className={classes.icon} aria-label="menu">
							<LocalOfferIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Reports" aria-label="reports">
						<IconButton className={classes.icon} aria-label="menu">
							<AssessmentIcon />
						</IconButton>
					</Tooltip>
				</Box>
			</nav>
			<div className={classes.lip} onClick={() => setOpen(!isOpen)}>
				<ExpandMoreIcon className={classes.svg} />
			</div>
		</div>
	);
}

const useStyles = makeStyles(theme => ({
	menu: {
		zIndex: 0,
		background: '#b60037',
		width: '300px',
		borderBottomRightRadius: '20px',
		borderBottomLeftRadius: '20px',
		margin: '0 auto',
		position: 'absolute',
		left: '50%',
		transition: 'all 0.2s ease-in',
		transform: 'translateX(-50%)',
		top: isOpen => (isOpen ? '48px' : '0px'),
	},
	icon: {
		color: 'white',
	},
	lip: {
		zIndex: 10000,
		background: '#b60037',
		position: 'absolute',
		left: '50%',
		transform: 'translateX(-50%)',
		borderBottomRightRadius: '10px',
		borderBottomLeftRadius: '10px',
		width: '30px',
		height: '15px',
		cursor: 'pointer',
	},
	svg: {
		color: 'white',
		position: 'absolute',
		top: '-6px',
		left: '3px',
		transition: 'all 0.2s ease-in',
		transform: isOpen => (isOpen ? 'rotate(180deg)' : 'rotate(0)'),
	},
}));
